import "./index.css";
import Nav from "./panele/Nav";
import Footer from "./panele/Footer";
import AnimowaneRuty from "./AnimowaneRuty";
function Everything() {
  return (
    <div id="everything">
      <Nav />
      <AnimowaneRuty />
      <Footer />
    </div>
  );
}

export default Everything;
